export const desc = "Obyte DAG explorer";
